"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import IImportationDetails from "@/interfaces/importation-details";
import importationDetailsService from "@/services/importation-details.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<IImportationDetails> | null>;

export interface Props extends RequestPagination {
  filters: IFilter<IImportationDetails>[];
}

type GetAllSwrParams = [string, number, number, IFilter<IImportationDetails>[]];

const useGetImportationDetails = ({ pageNumber, pageSize, filters }: Props): Return => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "importProcessId");

  const fetcher = useSWR<PaginatedResponse<IImportationDetails>, Error, GetAllSwrParams>(
    [SWR_KEYS.getImportationDetails, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      importationDetailsService.filter(_filters, { pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false }
  );
  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetImportationDetails;
